<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="newCritereRecherche">
    <div class="column is-12 pdb-0"
         :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'general.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div
      class="column is-12 overflow-auto is-marginless"
      :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeIntervention.filtre.nDemande')">
            <b-input v-model="newCritereRecherche.code ">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeIntervention.filtre.type')"
                      :items="constantes.TYPE_INTERVENTION"
                      v-model="typeInterventionSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="newCritereRecherche.dateCreationTime"
            :label="$t('listeIntervention.filtre.date')">
          </input-periode>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeIntervention.filtre.sujetDemande')">
            <b-input v-model="newCritereRecherche.actionLogistique">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeIntervention.filtre.patrimoineAdresse')">
            <qd-taginput type='is-primary' v-model="newCritereRecherche.adresses ">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeIntervention.filtre.ville')">
            <ville-tag-input-auto-complete
                :critere-recherche="this.newCritereRecherche"
                table-name="DemandeLogistique"/>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeIntervention.filtre.codePostal')">
            <qd-taginput type='is-primary' v-model="newCritereRecherche.codesPostaux"></qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeIntervention.filtre.etat')"
                      :items="constantes.ETAT_DEMANDE_INTERVENTION"
                      v-model="etatInterventionSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeIntervention.filtre.typeOt')">
            <qd-taginput v-if="typeOtTags"
                        v-model="typeOtSelected"
                        :data="typeOtTags"
                        autocomplete
                        open-on-focus
                        icon="magnify"
                        type="is-primary"
                        field="libelle"
                        @typing="getFilteredTypeOtTags"
                        @input="getTypeOtTags">
              <template slot="empty">
                {{$t('general.autocomplete.noRslt')}}
              </template>
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <libelle-tag-input
                      :label="$t('listeIntervention.filtre.source')"
                      :items="constantes.SOURCE_INTERVENTION"
                      v-model="sourceInterventionSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 is-marginless">
          <input-periode
            v-model="newCritereRecherche.datePlanification"
            :label="$t('listeIntervention.filtre.dateSouhaite')">
          </input-periode>
        </div>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeIntervention.filtre.demandeur')">
          <qd-taginput v-if="demandeurTags"
                      v-model="demandeurSelected"
                      :data="demandeurTags"
                      autocomplete
                      open-on-focus
                      icon="magnify"
                      type="is-primary"
                      field="decorator.nomPrenom"
                      @typing="getFilteredDemandeurTags"
                      @input="getDemandeurTags">
            <template slot="empty">
              {{$t('general.autocomplete.noRslt')}}
            </template>
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <agence-tag-input
                      :label="$t('listeIntervention.filtre.agence')"
                      :items="agencesSelectionnees"
                      v-model="newCritereRecherche.agencesIds">
        </agence-tag-input>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('general.button.appliquer')}}</button>

      <button
        class="mgt-10px button border-none has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRechercheIntervention
  from '@/services/logistique/intervention/genererCritereRechercheIntervention';
import {
  ETAT_DEMANDE_INTERVENTION,
  SOURCE_INTERVENTION,
  TYPE_INTERVENTION,
} from '@/configuration/logistique/intervention/interventionConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import inputPeriode from '@/components/general/inputPeriode';

const Parametres = createNamespacedHelpers('parametres');
const Societes = createNamespacedHelpers('societe');

export default {
  name: 'filtreListeIntervention',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newCritereRecherche: null,
      errors: [],
      constantes: {
        ETAT_DEMANDE_INTERVENTION,
        SOURCE_INTERVENTION,
        TYPE_INTERVENTION,
      },
      etatInterventionSelected: [],
      typeInterventionSelected: [],
      sourceInterventionSelected: [],
      demandeurTags: [],
      demandeurSelected: [],
      listeDemandeurBase: [],
      typeOtTags: [],
      typeOtSelected: [],
      listeTypeOtBase: [],
    };
  },
  components: {
    libelleTagInput,
    agenceTagInput,
    errorMsgComponent,
    VilleTagInputAutoComplete,
    inputPeriode,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
    }),
    appliquerCritere() {
      this.newCritereRecherche.etats = this.etatInterventionSelected.map((etat) => etat.key);
      this.newCritereRecherche.types = this.typeInterventionSelected.map((type) => type.key);
      this.newCritereRecherche.sources = this.sourceInterventionSelected.map((source) => {
        return source.key;
      });
      this.newCritereRecherche.demandeurIds = this.demandeurSelected.map((user) => {
        return user.id;
      });
      this.newCritereRecherche.typeOtIds = this.typeOtSelected.map((type) => {
        return type.id;
      });
      this.$emit('recherche', this.newCritereRecherche);
    },
    viderCritere() {
      this.demandeurSelected = [];
      this.etatInterventionSelected = [];
      this.sourceInterventionSelected = [];
      this.typeOtSelected = [];
      this.newCritereRecherche = cloneDeep(genererCritereRechercheIntervention());
      this.initializeFiltreType();
      this.initializeFiltreEtat();
      this.getDemandeurTags();
      this.getTypeOtTags();
    },
    getDemandeurTags() {
      this.demandeurTags = this.listeDemandeurBase.filter((user) => {
        return !this.demandeurSelected.map(c => c.id).includes(user.id);
      });
    },
    getFilteredDemandeurTags(text) {
      this.getDemandeurTags();
      this.demandeurTags = this.demandeurTags.filter((user) => {
        return user.decorator.nomPrenom.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getTypeOtTags() {
      this.typeOtTags = this.listeTypeOtBase.filter((typeOt) => {
        return !this.typeOtSelected.map(t => t.id).includes(typeOt.id);
      });
    },
    getFilteredTypeOtTags(text) {
      this.getTypeOtTags();
      this.typeOtTags = this.typeOtTags.filter((typeOt) => {
        return typeOt.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    initializeFiltreType() {
      if (this.newCritereRecherche.types.length > 0) {
        this.typeInterventionSelected = this.constantes.TYPE_INTERVENTION.filter((t) => {
          return this.newCritereRecherche.types.includes(t.key);
        });
      }
    },
    initializeFiltreEtat() {
      if (this.newCritereRecherche.etats.length > 0) {
        this.etatInterventionSelected = this.constantes.ETAT_DEMANDE_INTERVENTION.filter((c) => {
          return this.newCritereRecherche.etats.includes(c.key);
        });
      }
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametreUtilisateur();
        await this.loadParametres([PARAMETRES_KEYS.typeOt]);
        this.newCritereRecherche = cloneDeep(this.value);
        this.initializeFiltreEtat();

        if (this.newCritereRecherche.sources.length > 0) {
          this.sourceInterventionSelected = this.constantes.SOURCE_INTERVENTION.filter((c) => {
            return this.newCritereRecherche.sources.includes(c.key);
          });
        }
        this.initializeFiltreType();
        this.listeDemandeurBase = this.parametre(PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif);
        this.demandeurSelected = this.listeDemandeurBase.filter((c) => {
          return this.newCritereRecherche.demandeurIds.includes(c.id);
        });
        this.getDemandeurTags();

        this.listeTypeOtBase = this.parametre(PARAMETRES_KEYS.typeOt);
        this.typeOtSelected = this.listeTypeOtBase.filter((t) => {
          return this.newCritereRecherche.typeOtIds.includes(t.id);
        });
        this.getTypeOtTags();

        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societes.mapGetters({
      agencesSelectionnees: 'agenceActive',
    }),
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
